import React, { useEffect, useState } from 'react';

// components
import { Canvas } from './canvas';
import { Button } from 'shared/components/bulma/button';
import { Checkbox } from 'shared/components/bulma/checkbox';
import { ProductSearchInput } from 'shared/components/product';
import { Modal, ModalContent, ModalControl } from 'shared/components/bulma/modal';

// functions
import { UseToast, useToggle, ShowErrorToast, ShowSuccessToast, ShowWarningToast } from 'shared/functions';

import * as helper from "./helper";

const ModalReportEdit = ({ modal, handleModal, setLastBarcode }) => {

    const [stain, setStain] = useToggle();
    const [broken, setBroken] = useToggle();
    const [location, setLocation] = useState('');
    const [buttonMissing, setButtonMissing] = useToggle();
    const [formData, setFormData] = useState({ barcode: '', comment: '' });

    useEffect(() => {
        UseToast();
    }, []);

    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        setFormData({ ...formData, [name]: value ? value : checked });
    }

    const handleLocationChange = (event) => {
        setLocation(event.getSaveData());
    }

    const validBarcode = async (barcode) => {
        return await helper.validation(barcode);
    };

    const reset = () => {
        setFormData({ barcode: '', comment: '' });
        setStain(false);
        setBroken(false);
        setButtonMissing(false);
        handleModal(false);
    }

    const saveReport = async () => {
        if (!formData.barcode) {
            ShowWarningToast('Please enter a barcode!');
            return;
        }

        if (location === '') {
            ShowWarningToast('Please draw the location!');
            return;
        }

        if ([stain, broken, buttonMissing].every(x => x === false)) {
            ShowWarningToast('Please select the details!');
            return;
        }

        try {
            const valid = await validBarcode(formData.barcode);
            if (!valid) {
                ShowErrorToast('This barcode does not seem to exist. If it is not a typo, please report it!')
                await setFormData({ ...formData, barcode: '' });
                return;
            } else {
                await helper.saveRepairsReport({ stain, buttonMissing, broken, formData, location });
                setLastBarcode(formData.barcode);
                await reset();
                ShowSuccessToast('Successfully reported!');
            }
        } catch (error) {
            ShowErrorToast(error.message);
        }
    }

    const { barcode, comment } = formData;

    return (
        <Modal title="Report broken" isActive={modal} handleAccept={saveReport} handleReject={reset}>
            <ModalContent>
                <ProductSearchInput label="Barcode"
                    placeholder="Type barcode here"
                    id="barcode" value={barcode} name="barcode" onChange={handleChange} />

                <div className="field my-3">
                    <label className="label">Location</label>
                    <Canvas onChange={handleLocationChange} width={600} height={200} />
                </div>

                <label className="label">Comment</label>
                <textarea className="textarea" type="text" value={comment} placeholder="Comment" name="comment" onChange={handleChange} />

                <label className="label my-3">Details</label>
                <div className="columns">
                    <div className="column is-4">
                        <Checkbox name="stain" checked={stain} onChange={setStain}>
                            Stain
                        </Checkbox>
                    </div>
                    <div className="column is-4">
                        <Checkbox name="broken" checked={broken} onChange={setBroken}>
                            Broken
                        </Checkbox>
                    </div>
                    <div className="column is-4">
                        <Checkbox name="button-missing" checked={buttonMissing} onChange={setButtonMissing}>
                            Button Missing
                        </Checkbox>
                    </div>
                </div>
            </ModalContent>

            <ModalControl>
                <Button className="is-info" name="reset" onClick={reset}>
                    Cancel
                </Button>
                <Button className="is-primary" name="submit" onClick={saveReport}>
                    Report
                </Button>
            </ModalControl>
        </Modal>
    );
}

export { ModalReportEdit };
